import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4 8.25a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5zM4 14.25a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5z"
    }, null, -1)
  ])))
}
export default { render: render }